import * as React from "react";
const SvgFiRrFlipHorizontal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-flip-horizontal_svg__a)">
      <path d="M10.207.068H10.2a1 1 0 0 0-1.13.56L.375 19.758A3 3 0 0 0 3.106 24H10a1 1 0 0 0 1-1V1.046a1.01 1.01 0 0 0-.793-.978M9 22H3.106a1 1 0 0 1-.91-1.414L9 5.616zM23.625 19.759 14.93.628a1.02 1.02 0 0 0-1.152-.557 1 1 0 0 0-.778.975V23a1 1 0 0 0 1 1h6.894a3 3 0 0 0 2.731-4.241" />
    </g>
    <defs>
      <clipPath id="fi-rr-flip-horizontal_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFlipHorizontal;
